import { rejectApiError } from '../utility';
import { authttp, http, zero } from './http';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT_URL;

/**
 * Initiates the SSO login flow by redirecting the browser to the SSO gateway.
 * After successful authentication the gateway redirects back to `/sso/validate/`,
 * where ZINA BI exchanges the SSO ticket for session tokens.
 */
export const redirect_sso = () => {
    window.location = `${BASE_URL}/sso/login/?next=/sso/validate/`;
};

/**
 * Terminates the SSO session at the gateway level by redirecting to the SSO
 * logout endpoint. This must be called instead of a local-only logout when the
 * user authenticated via SSO so the gateway cookie is also invalidated.
 */
export const redirect_sso_logout = () => {
    window.location = `${BASE_URL}/sso/logout/`;
};

export default {
    redirect_sso,
    redirect_sso_logout,
    login: async (username, password) => {
        console.log(
            `%c Login `,
            'background: #ffff00; color: #000; padding: 8px; border-radius: 4px;'
        );
        return authttp.post('/api/login_token/', { username, password });
    },
    getAccess: async (value) => {
        return authttp
            .post('/profile/dummy/get/access/', value)
            .then(({ data }) => data)
            .catch(rejectApiError);
    },

    getSubProjectGetAccess: async () => {
        return authttp.get(`/rollout/api/subproject/get_access/`).then((response) => response.data);
    },
    getRolListGetAccess: async (id) => {
        return authttp.get(`/profile/api/rols/${id}/access_/`).then((response) => response.data);
    },
    getCustomerTeamGetAccess: async (id) => {
        return authttp
            .get(`/rollout/api/subproject/${id}/customer_team/`)
            .then((response) => response.data);
    },
    getProjectList: async () => {
        return authttp.get('/rollout/api/lading/').then((response) => response.data);
    },
    /**
     * Revokes the current DRF authtoken on the server (local-login sessions only).
     * The token is read before the Redux LOGOUT action clears localStorage, because
     * this call is fire-and-forget and runs asynchronously after the dispatch.
     */
    logout: async () => {
        // capture the token before LOGOUT clears it client-side, since this call doesn't wait for it
        const token = localStorage.getItem('_tk_');

        return http.post(
            '/api/logout/',
            {},
            {
                headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            }
        );
    },
    tokenRefresh: async () => {
        console.log(
            `%c Refresh `,
            'background: #ffff00; color: #000; padding: 8px; border-radius: 4px;'
        );
        return authttp.post('/api/refresh_token/', {
            refresh_token: localStorage.getItem('_rf_'),
            token: localStorage.getItem('_tk_'),
        });
    },
    /**
     * Exchanges the SSO ticket (set as a cookie by the gateway) for ZINA BI
     * session tokens. Called from the `/sso/validate/` route after the gateway
     * redirects back.
     */
    token: async () => {
        console.log(
            `%c Login `,
            'background: #ffff00; color: #000; padding: 8px; border-radius: 4px;'
        );
        return zero.post('/sso/token/');
    },
    validateToken: async () => {
        return authttp.post('/token/validate/', {});
    },
};
